export default {
  InternalDetailsItem: null,
  InternalDetailsChildren: [],
  InternalDetailsSiblingNext: null,
  InternalDetailsSiblingPrev: null,
  EidShown: false,
  embedFilters: [],
  treeOptions: {
    propertyNames: {
      state: "OPTIONS",
      children: "Children",
      data: "Data",
      expanded: "expanded",
      id: "Id",
      text: "Title",
      plainList: true,
    },
    filter: {
      matcher(query, node) {
        if (!query.Id) {
          var nodeFullPath =
            node.data && node.data.EmbedFullArea
              ? node.data.EmbedFullArea.toLowerCase()
              : "";
          if (nodeFullPath.length == 0) {
            nodeFullPath =
              node.data && node.data.EmbedFullArea
                ? node.data.EmbedFullArea
                : "";
          }
          if (nodeFullPath.length == 0) {
            if (node.data && node.data.Slug && node.data.Slug.length > 0) {
              nodeFullPath = node.data.Type + "/" + node.data.Slug;
            }
          }

          if (nodeFullPath[nodeFullPath.length - 1] != "/") {
            nodeFullPath += "/";
          }

          var matchWhat = encodeURIComponent(nodeFullPath.toLowerCase());
          var matchWhere = encodeURIComponent(query.toLowerCase());

          return matchWhat.indexOf(matchWhere) > -1;
        } else {
          var idToLookfor = query.Id;
          return node.data && node.data.Id == idToLookfor;
        }
      },
      showChildren: true,
    },
    dnd: true,
    // checkbox: true,
    autoCheckChildren: false,
    minFetchDelay: 1000,
  },
}
